import { render, staticRenderFns } from "./AgendaEventos.vue?vue&type=template&id=7b1f4ac4&scoped=true&"
import script from "./AgendaEventos.vue?vue&type=script&lang=js&"
export * from "./AgendaEventos.vue?vue&type=script&lang=js&"
import style0 from "./AgendaEventos.vue?vue&type=style&index=0&id=7b1f4ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1f4ac4",
  null
  
)

export default component.exports